import * as types from "./types";
const INITIAL_STATE = {
  packages: [],
  package: {}
};

const packagesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_ALL_PACKAGES_RESPONSE:
      return {
        ...state,
        packages: action.payload
      };
    case types.GET_SINGLE_PACKAGE_RESPONSE:
      return {
        ...state,
        package: action.payload.package
      };

    default:
      return state;
  }
};

export default packagesReducer;
